import { PayloadAction } from '@reduxjs/toolkit';
import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import ApprovalGateway from '~apis/approval';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';
import { TUpdateStockOutStatusReduxParams } from '~types/feat/approval';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages, SuccessMessages } from '~utils/constants';
import { TransactionStatusEnum } from '~utils/enums';

export default function* watchUpdateStockOutStatus(api: ApprovalGateway): SagaWatcherReturnType {
    yield takeEvery('approval/approvalUpdateStockOutStatusAttempt', handleUpdateStockOutStatus, api);
}

function* handleUpdateStockOutStatus(api: ApprovalGateway, data: PayloadAction<TUpdateStockOutStatusReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        id,
        status,
    } = data.payload;

    const response = yield* call([api, api.updateStockOutStatus], {
        authToken,
        id,
        status,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.approvalUpdateStockOutStatusFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        const pendingStockOutListing = reduxState.approval.pendingStockOutListing.data;
        const pendingStockOutListingIndex = reduxState.approval.pendingStockOutListing.index;
        const oldStatus = pendingStockOutListing.find(item => item.id === id)?.status;
        const successMessage = status === TransactionStatusEnum.Approved
            ? SuccessMessages.ApprovalApproveTransactionSuccess
            : status === TransactionStatusEnum.Rejected
                ? SuccessMessages.ApprovalRejectTransactionSuccess
                : '';

        yield put(combinedActions.approvalSetConfirmUpdateStockOutStatusModalIsOpen(false));

        toast.success(successMessage);

        if (status === oldStatus) {
            yield put(combinedActions.approvalUpdateStockOutStatusSuccess());
            return;
        }

        if (pendingStockOutListing.length === 1) {
            yield put(combinedActions.approvalSetPendingTransactionListingIndex({ index: pendingStockOutListingIndex > 0 ? pendingStockOutListingIndex - 1 : 0 }));
        }

        yield put(combinedActions.approvalGetPendingStockOutListingAttempt());
        yield put(combinedActions.approvalUpdateStockOutStatusSuccess());
    }
}
